import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  animation: fadeIn 0.2s ease-in-out;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const Modal = styled.div`
  background-color: ${theme.colors.white};
  border-radius: 20px;
  padding: 40px 30px;
  max-width: 340px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  animation: slideUp 0.3s ease-in-out;

  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

const Title = styled.h2`
  font-family: ${theme.typography.headingFont};
  font-size: 22px;
  font-weight: 700;
  color: ${theme.colors.deepNavy};
  margin: 0 0 16px;
`;

const Body = styled.p`
  font-family: ${theme.typography.bodyFont};
  font-size: 15px;
  color: ${theme.colors.slateGray};
  line-height: 1.5;
  margin: 0 0 28px;
`;

const ContinueButton = styled.button`
  background-color: ${theme.colors.brandYellow};
  color: ${theme.colors.deepNavy};
  border: none;
  border-radius: 12px;
  padding: 14px 32px;
  font-family: ${theme.typography.bodyFont};
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 4px 8px rgba(255, 209, 0, 0.2);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(255, 209, 0, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const WelcomeBackModal = ({ onClose }) => {
  const { t } = useTranslation();
  return (
    <Overlay onClick={onClose}>
      <Modal onClick={e => e.stopPropagation()}>
        <Title>{t('welcomeBack.title')}</Title>
        <Body>
          {t('welcomeBack.message')}
        </Body>
        <ContinueButton onClick={onClose}>{t('welcomeBack.button')}</ContinueButton>
      </Modal>
    </Overlay>
  );
};

export default WelcomeBackModal;
